module.exports = __webpack_public_path__ + "img/3_115.d3b3917b.png";